import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createApiClient } from '../../api/client';
import PickerModal from '../components/PickerModal';
import { LANGUAGES } from '../data/languages';
import '../mobile.css';

const MobileUpdateProfile = ({ API_URL }) => {
  const navigate = useNavigate();
  const email = localStorage.getItem('email') || '';

  const [firstName, setFirstName] = useState(localStorage.getItem('firstName') || '');
  const [lastName, setLastName] = useState(localStorage.getItem('lastName') || '');
  const [designation, setDesignation] = useState(localStorage.getItem('designation') || '');
  const [nativeLanguage, setNativeLanguage] = useState(localStorage.getItem('language') || '');
  const [showLanguagePicker, setShowLanguagePicker] = useState(false);

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const [showDeleteFlow, setShowDeleteFlow] = useState(false);
  const [deleteOtpSent, setDeleteOtpSent] = useState(false);
  const [deleteOtp, setDeleteOtp] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  const handleUpdate = async () => {
    setLoading(true);
    setErrorMessage('');

    try {
      const api = createApiClient(API_URL);
      await api.put('/user', { firstName, lastName, email, mobile: email, designation, nativeLanguage });
      localStorage.setItem('firstName', firstName);
      localStorage.setItem('lastName', lastName);
      localStorage.setItem('designation', designation);
      localStorage.setItem('language', nativeLanguage);
      setSuccessMessage('Profile updated successfully.');
    } catch {
      setErrorMessage('Failed to update profile. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const sendDeleteOtp = async () => {
    setErrorMessage('');
    try {
      const api = createApiClient(API_URL);
      await api.get('/user/delete/otp');
      setDeleteOtpSent(true);
    } catch {
      setErrorMessage('Failed to send OTP. Please try again.');
    }
  };

  const handleDeleteAccount = async () => {
    setIsDeleting(true);
    setErrorMessage('');

    try {
      const api = createApiClient(API_URL);
      await api.delete('/user', { data: { email, otp: deleteOtp } });
      localStorage.clear();
      navigate('/', { replace: true });
    } catch {
      setErrorMessage('Failed to delete account. Please check the OTP and try again.');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div>
      <h2 style={{ fontSize: '20px', fontWeight: 700, color: '#094268', marginBottom: '15px' }}>Profile</h2>

      <input
        placeholder="First Name"
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        style={{ width: '100%', boxSizing: 'border-box', borderWidth: 1, borderStyle: 'solid', borderColor: '#ccc', borderRadius: '8px', padding: '12px', marginBottom: '12px' }}
      />
      <input
        placeholder="Last Name"
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
        style={{ width: '100%', boxSizing: 'border-box', borderWidth: 1, borderStyle: 'solid', borderColor: '#ccc', borderRadius: '8px', padding: '12px', marginBottom: '12px' }}
      />
      <input
        placeholder="Designation"
        value={designation}
        onChange={(e) => setDesignation(e.target.value)}
        style={{ width: '100%', boxSizing: 'border-box', borderWidth: 1, borderStyle: 'solid', borderColor: '#ccc', borderRadius: '8px', padding: '12px', marginBottom: '12px' }}
      />

      <div
        onClick={() => setShowLanguagePicker(true)}
        style={{ display: 'flex', justifyContent: 'space-between', border: '1px solid #ccc', borderRadius: '8px', padding: '12px', marginBottom: '12px', cursor: 'pointer' }}
      >
        <span style={{ color: nativeLanguage ? '#000' : '#999' }}>{nativeLanguage || 'Preferred Language'}</span>
        <span style={{ color: '#0A426A', fontWeight: 600 }}>Select</span>
      </div>

      <button onClick={handleUpdate} disabled={loading} className="m-button-primary">
        {loading ? <div className="m-spinner" style={{ margin: '0 auto' }} /> : 'Save'}
      </button>

      {/* <div style={{ marginTop: '30px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
        <button
          onClick={() => setShowDeleteFlow(true)}
          className="m-pill-btn"
          style={{ color: '#D32F2F', fontWeight: 600 }}
        >
          Delete Account
        </button>
      </div> */}

      {showLanguagePicker && (
        <PickerModal title="Preferred Language" options={LANGUAGES} selected={nativeLanguage} onSelect={setNativeLanguage} onClose={() => setShowLanguagePicker(false)} />
      )}

      {showDeleteFlow && (
        <div className="m-popup-overlay">
          <div className="m-popup-container">
            <h3>Delete Account</h3>
            {!deleteOtpSent ? (
              <>
                <p>An OTP will be sent to your registered mobile to confirm account deletion.</p>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                  <button onClick={() => setShowDeleteFlow(false)} className="m-pill-btn" style={{ color: '#094268' }}>Cancel</button>
                  <button className="m-button-primary" style={{ width: 'auto', padding: '8px 14px' }} onClick={sendDeleteOtp}>Send OTP</button>
                </div>
              </>
            ) : (
              <>
                <input
                  placeholder="Enter OTP"
                  value={deleteOtp}
                  onChange={(e) => setDeleteOtp(e.target.value)}
                  style={{ width: '100%', boxSizing: 'border-box', borderWidth: 1, borderStyle: 'solid', borderColor: '#ccc', borderRadius: '8px', padding: '10px', marginBottom: '12px' }}
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                  <button onClick={() => setShowDeleteFlow(false)} className="m-pill-btn" style={{ color: '#094268' }}>Cancel</button>
                  <button className="m-button-primary" style={{ width: 'auto', padding: '8px 14px', background: '#D32F2F' }} onClick={handleDeleteAccount} disabled={isDeleting || !deleteOtp}>
                    {isDeleting ? <div className="m-spinner" style={{ margin: '0 auto' }} /> : 'Confirm Delete'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {errorMessage && (
        <div className="m-popup-overlay">
          <div className="m-popup-container">
            <h3>Error</h3>
            <p>{errorMessage}</p>
            <button className="m-button-primary" onClick={() => setErrorMessage('')}>OK</button>
          </div>
        </div>
      )}

      {successMessage && (
        <div className="m-popup-overlay">
          <div className="m-popup-container">
            <h3>Success</h3>
            <p>{successMessage}</p>
            <button className="m-button-primary" onClick={() => setSuccessMessage('')}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileUpdateProfile;
